import { CartState } from '@buy-viasat/redux/src/cart';
import { FiberDiscounts, Promo } from '@buy-viasat/types/build/bv';
import { AemProductFamily } from '@buy-viasat/utils';

export enum FeesAndDiscountsKind {
  ACCOUNT_SETUP = 'bep.ofm.product-types.account-setup-fee',
}

export const productFamilyAemPrefix = (
  isCafII: boolean,
  isChoicePlans: boolean,
  isDiamondPlans: boolean,
  isVS2LargePlans: boolean,
) =>
  isCafII
    ? AemProductFamily.CAF
    : isChoicePlans
      ? AemProductFamily.CHOICE
      : isDiamondPlans
        ? AemProductFamily.DIAMOND
        : isVS2LargePlans
          ? AemProductFamily.VS2_LARGE
          : AemProductFamily.DEFAULT;

export type CheckoutCartProps = {
  displayMobileCart: boolean;
  translationKeys: {
    header: {
      speedDetails: {
        above: string;
        below: string;
      };
      availableAddons: string;
    };
    serviceDetails: {
      hideLabel: string;
      showLabel: string;
      changeButton: string;
      planNameSuffix: string;
      free: string;
      categoryName: string;
      optionalServices: string;
      priceAfterPromotion: (price: string, duration: string) => string;
    };
    addons: {
      stream: string;
      voice: string;
      easyCare: string;
      officeHours: string;
      edit: string;
      remove: string;
      priceAfterPromotion?: (price: string, duration: string) => string;
    };
    totalMonthly: {
      title: string;
      priceAfterPromotion?: (price: string, duration: string) => string;
      extraTaxesInfoText: string;
    };
    dueToday: {
      title: string;
      total: string;
      extraTaxesInfoText?: string;
      calculatedLater: string;
      free: string;
    };
    mobile: {
      dueMonthlyTitle: string;
      dueTodayTitle: string;
    };
    extraTaxesDescriptionText: string;
    fiberDiscountFirstMonthFreeText: string;
  };
};

export type selectedAddons = {
  addonItems: Array<AddonItem>;
  total: number;
  totalPriceWithoutPromotions: number;
  duration: number;
};
export type AddonItem = {
  isBundle: boolean;
  displayOrder: number;
  categoryName: string | null;
  name: string;
  productTypeId: string;
  price: number;
  promo: Promo | null;
  shouldHideBundleAddon: boolean;
};

export type calculationData = {
  cartItems: CartState['cartItems'];
  selectedAddons: selectedAddons;
  shouldDisplayClosingOffer: boolean;
  shouldDisplayThirdMonthFreeService: boolean;
  fiberDiscount: FiberDiscounts | undefined | null;
  priceClosingOffer: number;
  durationClosingOffer: number;
  price: number;
  priceWithPromo: number;
  promoDuration?: number;
  totalPrice: number;
  totalPriceWithPromo: number;
  totalPriceWithoutPromotions: number;
  totalCart: number;
  totalCartWithPromo: number;
  totalCartWithoutPromotions: number;
  isBackgroundAPICallLoading: boolean;
};

export type DurationPromo = {
  planPromoDuration?: number;
  addonPromoDuration?: number;
};
